/**
 * Когда весь js отработал и страница построилась,
 * показываем её
 */

/*if (localStorage.getItem('preload')) {
    App.H.addClass('_preloaded');
}*/

$(document).ready(function() {
    setTimeout(() => {
        App.H.addClass('_preloaded');
        localStorage.setItem('preload', 'true');
        //App.W.trigger('preloaded');
    }, 1000);
});

